import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from 'lodash';

import { ACTION_RULES } from '../../../../helpers/authorization';

import { Content } from '../../../../common/components/layout';
import Card from '../../../../common/components/ui/card/card';
import { InputLabel, SelectLabel } from '../../../../common/components/form/fields';
import ResponsiveTable from '../../../../common/components/table/table';
import Loading from "../../../../common/components/ui/loading/loading";

import { getListAll as getAllStates } from '../state/stateActions';
import types from './cityTypes';
import { getListFiltered as filterCities, getList, getPage, remove } from './cityActions';
import { setLoading } from "../../../../helpers/redux";

const columns = [
	{
		title: "Nome",
		dataIndex: "name",
		key: "name",
		searchable: true,
	},
	{
		title: "Latitude",
		dataIndex: "lat",
		key: "lat",
		searchable: true,
	},
	{
		title: "Longitude",
		dataIndex: "lon",
		key: "lon",
		searchable: true,
	},
	{
		title: "Fuso horário",
		dataIndex: "timezone",
		key: "timezone",
		searchable: true,
	},
	{
		title: "Estado",
		dataIndex: "state",
		key: "state",
		searchable: false,
		render: (text, record) => _.isUndefined(record.state) || _.isNull(record.state) ? '' : record.state.name
	},
	{
		title: "País",
		dataIndex: "country",
		key: "country",
		searchable: false,
		render: (text, record) => record.country_letters
	}
];

class City extends Component {
	constructor(props) {
		super(props);
		this.props.setLoading(types.CITY_LOADING, true);
		this.props.getList();
		this.props.getAllStates();
		this.state = {
			isVisible: true,
			field: {
				label: 'Escolha',
				value: null
			},
			search: ''
		}
	}

	toggleModal = () => {
		this.setState({
			isVisible: !this.state.isVisible
		})
	}

	filterCities = (key, value) => {
		if (key && value !== '') {
			const filter = `like=${key}(^${value})&limit=20`
			this.props.filterCities(filter);
		} else if(key && value === '') {
			this.props.filterCities();
		}
	}

	selectOptions = () => {
		const listFields = [];
		for (let i in columns) {
			if(columns[i].searchable) {
				listFields.push({
					label: columns[i].title,
					value: columns[i].dataIndex
				})
			}
		}
		return listFields
	}

	handleSelectChange = (e) => {
		this.setState({
			field: e
		})
	}

	handleInputChange = (e) => {
		this.setState({
			search: e.target.value
		}, () => this.filterCities(this.state.field.value, this.state.search))
	}

	render() {
		const { pagination, getPage } = this.props;
		if (this.props.loading) {
			return (
				<Loading
					isVisible={this.props.loading}
					overlay={false}
                />
			)
		}
		return (
			<Content>
				<Card header title='Filtros'>
					<SelectLabel
						meta={{ touched: false, error: false }}
						cols='12 4 4 3'
						options={this.selectOptions()}
						className="form-control basic-multi-select"
						classNamePrefix="select"
						style={{ textAlign: "left", fontSize: "1.6rem", paddingBottom: 0 }}
						selectStyle={{ fontSize: "1.6rem", padding: 20, borderRadius: ".5rem" }}
						input={{
							value: this.state.field,
							onChange: this.handleSelectChange
						}}
					/>
					<InputLabel
						meta={{touched: false, error: false}}
						cols='12 6 6 6'
						inputStyle={{ fontSize: "1.6rem", padding: 20, borderRadius: ".5rem" }}
						style={{ textAlign: "left", fontSize: "1.6rem", paddingBottom: 0 }}
						type='text'
						placeholder='Digite aqui'
						input={{
							value: this.state.search,
							onChange: this.handleInputChange
						}}
					/>
				</Card>
				<ResponsiveTable
					// hasHeader
					customID='_id'
					rowKey={(record)=> record._id}
					columns={columns}
					rows={this.props.cities}
					router={this.props.router}
					onDelete={this.props.remove}
					actions_permissions={ACTION_RULES.can_all}
					pagination={pagination}
					getPagination={getPage}
				/>
			</Content>
		)
	}
}

const mapStateToProps = (state) => {
    return {
        cities: state.city.list.content,
        pagination: state.city.list.pagination,
        loading: state.city.loading
    }
}
const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({ getList, getPage, remove, setLoading, getAllStates, filterCities }, dispatch),
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(City);
